<template>
  <div class="mc-trackvideo-card--video" :class="{ 'mc-trackvideo-card--video-fill': isFill }">
    <video-stream-player
      v-if="isFlespiHowen && source.src"
      :ref="`videoPlayer${source.id}`"
      class="vjs-custom-skin"
      :src="source.src"
      :playerId="`${source.id}`"
      @ready="onPlayerFlespiReady($event)"
      @error="onPlayerFlespiError($event)"
      @loadeddata="onPlayerFlespiLoadedData($event)"
    />
    <video-stream-vss
      v-else-if="isVssHowen"
      :ref="`videoPlayer${source.id}`"
      :channel="source.camera"
      :imei="imei"
      :playlist-id="playlistId"
      :type="'live'"
      :default-open-audio="!muted"
      @ready="onPlayerVssReady($event)"
    />
    <video-stream-flv
      v-else
      :ref="`videoPlayer${source.id}`"
      class="vjs-custom-skin"
      type="stream"
      :src="source.src"
      :playerId="`${source.id}`"
      :isRecording="isRecording"
      @ready="onReady"
      @loadeddata="onLoadDataFlv"
      @error="onError"
      @receiveStatisticInfo="receiveStatisticInfo"
      @destroyed="onDestroyed"
    />
    <div class="mc-trackvideo-card--video-mic" v-if="showMic">
      <MicAnimation />
    </div>
    <div class="mc-trackvideo-card--video-action d-flex justify-content-between">
      <div>
        <span class="mc-trackvideo-card--video-action-bandwitch">{{ bandwidth }} KB/s</span>
        <span
          ><i v-if="!muted" @click="muteVideo" class="mc-fa icon-outline_volume-up"></i>
          <i v-else @click="muteVideo" class="mc-fa icon-outline_volume-off"></i
        ></span>
      </div>
      <div>
        <span @click="captureImage">
          <i class="mc-fa icon-fill_camera"></i><span>{{ $t('trackVideo.snapshots') }}</span></span
        >
        <span v-if="$store.state.config.vsms2_video_streaming_record" @click="startRecording">
          <i class="mc-fa icon-fill_videorecord"></i><span>{{ $t('trackVideo.record') }}</span>
        </span>
      </div>
      <div>
        <span><i class="mc-fa icon-fill_fit-screen"></i></span>
        <span @click="detailVideo()">
          <i class="mc-fa icon-fill_fullscreen"></i>
          <i class="mc-fa icon-fill_exit-fullscreen"></i>
        </span>
      </div>
    </div>
    <span v-if="isRecording" @click="stopRecording" class="mc-trackvideo-card--video-action-record">
      <u><span>Hentikan Rekaman</span></u> | Merekam : {{ `${timerString}` }}
    </span>
  </div>
</template>
<script>
import VideoStreamFlv from '@/components/Video/VideoStreamFlv.vue'
import VideoStreamPlayer from '@/components/Video/VideoStreamPlayer.vue'
import VideoStreamVss from '@/components/Video/VideoStreamVss.vue'
import Whammy from 'whammy'
import { Helper } from '@/mixin/helper'
import moment from 'moment'
import MicAnimation from '../MicAnimation.vue'
import { mapGetters } from 'vuex'

moment.locale('id')

export default {
  components: {
    VideoStreamFlv,
    MicAnimation,
    VideoStreamVss,
    VideoStreamPlayer,
  },
  name: 'VideoState',

  mixins: [Helper],

  props: {
    source: {
      required: true,
    },
    index: {
      required: true,
    },
    playlistId: {
      required: true,
      type: String,
    },
  },

  data() {
    return {
      muted: true,
      isFill: true,

      capturedFrames: [],
      isRecording: false,
      recordInterval: null,
      bandwidth: 0,
      supportedType: '',

      hour: 0,
      minute: 0,
      second: 0,
      count: 0,
      timerString: '00:00:00',
      watchInterval: null,

      errorState: 0,
      readyState: false,
      timeoutVideo: null,
      maxAttemptsError: 10,
    }
  },

  computed: {
    ...mapGetters('video', ['flespiHowenVehicleIds', 'fleetsList']),
    showMic() {
      const callState = this.$store.state.video.voipState[this.source.vehicleId]
      if (!callState || callState.state !== 'onGoing') return false
      return true
    },
    isFlespiHowen() {
      return this.flespiHowenVehicleIds.includes(parseInt(this.source.vehicleId))
    },
    isVssHowen() {
      return this.source.deviceType === 'vss-howen'
    },
    imei() {
      return this.fleetsList.find(
        (fleet) => parseInt(fleet.vehicleId) === parseInt(this.source.vehicleId)
      )?.vehicle?.imei
    },
  },

  beforeDestroy() {
    clearTimeout(this.timeoutVideo)
  },

  methods: {
    onDestroyed(videoId, flv) {
      flv.destroy()
    },
    detailVideo() {
      document.body.classList.toggle('mc-trackvideo-fullscreen--detail')
      this.$emit('fullscreen', this.index, this.source)
    },

    async onReady() {
      if (this.readyState) return
      this.readyState = true

      const isPlayFirstTime = this.source.videoStatus === 'connecting'

      if (isPlayFirstTime) {
        this.$emit('startPlay', this.index, this.source)
      }

      clearTimeout(this.timeoutVideo)
      this.timeoutVideo = setTimeout(async () => {
        this.$store.state.video.fleets.find(
          (vehicle) => vehicle.vehicleId === parseInt(this.source.vehicleId)
        ).vehicle.imei
        this.$emit('setPlaylistTimeout', this.index, this.source)
      }, 5 * 60 * 1000)

      this.errorState = 0

      this.$emit('ready')
    },

    onLoadDataFlv(data, bandwidth) {
      this.bandwidth = bandwidth
      this.$emit('load')
    },

    onError() {
      if (this.source.videoStatus === 'timeout') return

      const maxAttempts = this.maxAttemptsError
      if (this.readyState) {
        this.$emit('connecting')
        this.errorState = 0
        this.readyState = false
      }

      if (this.errorState == maxAttempts) {
        clearTimeout(this.timeoutVideo)
        this.errorState = 0
        this.$emit('error')
        return
      }

      setTimeout(() => {
        this.$refs[`videoPlayer${this.source.id}`].initialize()
        this.errorState++
      }, 1000)
    },

    pauseVideo() {
      this.$emit('pause')
    },

    async muteVideo() {
      if (this.isRecording) return
      this.muted = !this.muted
      await this.$nextTick()
      if (this.isVideoDemo) {
        var refsName = `videoPlayerDemo${this.source.id}`
        this.$refs[refsName].player.muted = !this.$refs[refsName].player.muted
      } else if (this.isVssHowen) {
        this.$refs[`videoPlayer${this.source.id}`].setOpenAudio(!this.muted)
      } else {
        this.$emit('mute')
      }
    },

    captureImage() {
      const ref = this.$refs[`videoPlayer${this.source.id}`]

      const canvas = document.createElement('canvas')
      canvas.width = ref.player.videoWidth
      canvas.height = ref.player.videoHeight

      canvas.setAttribute('crossOrigin', 'Anonymous')
      const ctx = canvas.getContext('2d')
      ctx.drawImage(ref.player, 0, 0, canvas.width, canvas.height)
      const dataURL = canvas.toDataURL('image/png') // Convert canvas to data URL

      const a = document.createElement('a')
      a.href = dataURL
      const dateTimes = moment(new Date()).format('YYYYMMDD-HHmmss')
      a.download = `${this.source.licensePlate}-kamera${this.source.camera}-live-${dateTimes}.png` // Set the filename for the downloaded image
      a.click()
    },

    determineSupportedType() {
      const supportedTypes = [
        'video/webm;codecs=vp8',
        'video/webm;codecs=vp9',
        'video/webm;codecs=vp8.0',
        'video/webm;codecs=vp9.0',
        'video/webm',
        'video/mp4',
        'video/ogg',
      ]

      for (const type of supportedTypes) {
        if (MediaRecorder.isTypeSupported(type)) {
          this.supportedType = type
          break
        }
      }

      if (!this.supportedType) {
        console.error('No supported MIME type found for MediaRecorder')
      }
    },

    startRecording() {
      this.determineSupportedType()
      this.startWatch()
      this.isRecording = true

      this.capturedFrames = []
      this.recordInterval = setInterval(this.captureFrame(), 1000) // Capture frame every second
    },
    startWatch() {
      this.watchInterval = setInterval(() => {
        this.count++

        if (this.count == 100) {
          this.second++
          this.count = 0
        }

        if (this.second == 60) {
          this.minute++
          this.second = 0
        }

        if (this.minute == 60) {
          this.hour++
          this.minute = 0
          this.second = 0
        }

        let hrString = this.hour
        let minString = this.minute
        let secString = this.second

        if (this.hour < 10) {
          hrString = '0' + hrString
        }

        if (this.minute < 10) {
          minString = '0' + minString
        }

        if (this.second < 10) {
          secString = '0' + secString
        }

        this.timerString = `${hrString}:${minString}:${secString}`
      }, 10)
    },
    stopWatch() {
      clearInterval(this.watchInterval)
      this.hour = 0
      this.minute = 0
      this.second = 0
      this.count = 0
      this.timerString = '00:00:00'
    },
    captureFrame() {
      const ref = this.$refs[`videoPlayer${this.source.id}`]

      const canvas = document.createElement('canvas')
      canvas.width = ref.player.videoWidth
      canvas.height = ref.player.videoHeight
      const ctx = canvas.getContext('2d')
      ctx.drawImage(ref.player, 0, 0, canvas.width, canvas.height)
      const dataURL = canvas.toDataURL('image/jpg') // Convert captured frame to DataURI
      this.capturedFrames.push(dataURL)
    },
    async stopRecording() {
      this.stopWatch()
      this.isRecording = false

      clearInterval(this.recordInterval)
      await this.$nextTick()
      this.downloadVideo()
    },
    downloadVideo() {
      const framerate = 30 // Frames per second
      const encoder = new Whammy.Video(framerate)

      // Convert captured frames to Blob objects
      this.capturedFrames.forEach((frameDataURL) => {
        const blob = new Blob(frameDataURL, { type: 'image/jpg' })
        encoder.add(blob)
      })

      // Finish encoding and get the Blob representing the video
      const blobb = encoder.compile()

      // Create a URL for the Blob
      const url = URL.createObjectURL(blobb)

      // Create a link element to trigger the download
      const a = document.createElement('a')
      a.href = url
      a.download = 'recorded_video.webm' // Set the filename for the downloaded video
      document.body.appendChild(a)
      a.click()

      // Cleanup
      document.body.removeChild(a)
      URL.revokeObjectURL(url)
    },
    dataURItoBlob(dataURI) {
      const byteString = atob(dataURI.split(',')[1])
      const mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0]
      const arrayBuffer = new ArrayBuffer(byteString.length)
      const uint8Array = new Uint8Array(arrayBuffer)
      for (let i = 0; i < byteString.length; i++) {
        uint8Array[i] = byteString.charCodeAt(i)
      }
      return new Blob([arrayBuffer], { type: mimeString })
    },
    receiveStatisticInfo() {
      this.$emit('setPlaylistReady', this.index, this.source)
    },
    onPlayerFlespiReady() {
      var refsName = `videoPlayer${this.source.id}`
      this.$refs[refsName].player.play()
      this.$refs[refsName].player.muted = true
    },
    onPlayerFlespiError() {
      this.$emit('connecting')
    },
    onPlayerFlespiLoadedData() {
      this.$emit('ready')

      var refsName = `videoPlayer${this.source.id}`
      this.$refs[refsName].player.play()
      this.$refs[refsName].player.muted = true
    },
    onPlayerVssReady() {
      clearTimeout(this.timeoutVideo)
      this.timeoutVideo = setTimeout(async () => {
        this.$emit('setPlaylistTimeout', this.index, this.source)
      }, 5 * 60 * 1000)
      this.$emit('setPlaylistReady', this.index, this.source)
    },
  },
}
</script>
